import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { IntegrationsMarketplaceGridAvailableDataProviderFactory } from '../factory/IntegrationsMarketplaceGridAvailableDataProviderFactory';
import {
  CustomTemplateListRequest,
  CustomTemplateListResponse,
  GetItemsResponse
} from "../../../ui/gzCustomTemplateList/types";
import {
  IntegrationsMarketplaceGridAvailableNirvanaDataProvider
} from "../dataProvider/IntegrationsMarketplaceGridAvailableNirvanaDataProvider";

export class IntegrationsMarketplaceGridAvailableRepository extends BaseWebComponentRepository {
  public dataProviderFactory: IntegrationsMarketplaceGridAvailableDataProviderFactory;
  public dataProvider: IntegrationsMarketplaceGridAvailableNirvanaDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new IntegrationsMarketplaceGridAvailableDataProviderFactory(),
    });
  }

  async getItems(request: CustomTemplateListRequest): Promise<GetItemsResponse> {
    return this.dataProvider.getItems(request);
  }
}
